import React, { Component } from 'react'
import styles from './styles.scss';
import { string, func, oneOf } from 'prop-types';
import classnames from 'classnames';
import { Error as ErrorIcon, Warning as WarningIcon } from '@material-ui/icons';
import {
  CircularProgress,
  Tooltip,
  withStyles
} from '@material-ui/core';

const CustomTooltip = withStyles({
  tooltipPlacementRight: {
    margin: '0px 7px'
  }
})(Tooltip);

export const PLAYOUT_IMPORT_STATUS = {
  COMPLETED: 'complete',
  PROCESSING: 'running',
  WARNING: 'warning',
  ERROR: 'error',
  INQUEUE: 'queued'
}
class ImportStatus extends Component {

  static propTypes = {
    status: oneOf(Object.values(PLAYOUT_IMPORT_STATUS)),
    processTooltip: string,
    inQueueTooltip: string,
    errorTooltip: string,
    customTooltip: string,
    completeTooltip: string,
    onDelete: func,
    onReProcess: func,
    onShowErrors: func,
    onErrorsResolved: func
  };

  static defaultProps = {
    status: 'processing',
    processTooltip: 'Processing...',
    inQueueTooltip: 'In queue...',
    errorTooltip: 'Errors',
    completeTooltip: 'Complete'
  };

  handleError = () => {
    const { onError } = this.props;
    onError && onError();
  }
  
  handleWarning = () => {
    const { onWarning } =this.props;
    onWarning && onWarning();
  }

  renderStatusIcon = () => {
    const {
      status,
      processTooltip,
      inQueueTooltip,
      errorTooltip,
      completeTooltip,
      customTooltip,
    } = this.props;

    switch (status) {
      case PLAYOUT_IMPORT_STATUS.COMPLETED:
        return (
          <CustomTooltip
            data-test="completeTooltip"
            title={completeTooltip}
            placement="right"
          >
            <span className={classnames("icon-circlecheck", styles.checkIcon)} />
          </CustomTooltip>
        );
      case PLAYOUT_IMPORT_STATUS.ERROR:
        return (
          <CustomTooltip
            data-test="errorTooltip"
            title={errorTooltip}
            placement="right"
          >
            <ErrorIcon className={styles.errorIcon} onClick={this.handleError} />
          </CustomTooltip>
        );
      case PLAYOUT_IMPORT_STATUS.WARNING:
        return (
          <CustomTooltip
            data-test="warningTooltip"
            title={customTooltip}
            placement="right"
          >
            <ErrorIcon onClick={this.handleWarning} className={styles.warningIcon} />
          </CustomTooltip>
        );
      case PLAYOUT_IMPORT_STATUS.PROCESSING:
        return (
          <CustomTooltip
            data-test="processingTooltip"
            title={processTooltip}
            placement="right"
          >
            <CircularProgress size={16} />
          </CustomTooltip>
        );
      default:
        // default in queue icon
        return (
          <CustomTooltip
            data-test="inQueueTooltip"
            title={inQueueTooltip}
            placement="right"
          >
            <CircularProgress size={16} />
          </CustomTooltip>
        );
    }
  }

  render() {

    return (
      <React.Fragment>
        <div className={styles.iconContainer} >
          {this.renderStatusIcon()}
        </div>
      </React.Fragment>
    )
  }
}
export default ImportStatus;
